export const DOMAIN_SUB_DOMAIN_FETCH_DATA = 'domainSubDomainFetchData'
